import React from 'react';
import PropTypes from 'prop-types';
import * as FormStructure from '../../FormStructure';
import { TmntHtml } from '../../Common';

export default function EmailUsHelpDirections({ text }) {
  return (
    <FormStructure.FormGroup>
      <FormStructure.FormCell>
        <TmntHtml
          testId="email-us-help-directions__text"
          classNames="email-us-help-directions__text"
          tmnt={text}
        />
      </FormStructure.FormCell>
    </FormStructure.FormGroup>
  );
}

EmailUsHelpDirections.propTypes = {
  text: PropTypes.string.isRequired,
};
